<template>

  <Toast :group="page.name" position="bottom-center" />
  <Loader v-if="loader" />

  <div class="page">

   <div class="formgrid grid ">
      <div class="field col-12 md:col-6">
          <label>Da Iva:</label>
          <Dropdown v-model="selectedDaIva" :options="ivas" optionLabel="name" optionValue="name" placeholder="Seleziona iva" class="inputfield w-full" />
      </div>
      <div class="field col-12 md:col-6">
          <label>Ad Iva:</label>
          <Dropdown v-model="selectedAdIva" :options="ivas" optionLabel="name" optionValue="name" placeholder="Seleziona iva" class="inputfield w-full" />
      </div>
   </div>

    <DataTable :value="items" v-model:selection="selectedItems" :filters="filters" responsiveLayout="scroll">
      <Column selectionMode="multiple" style="width: 3rem" :exportable="false"></Column>
      <Column field="code" header="Pod"></Column>
      <Column field="cliente" header="Cliente"></Column>
      <Column field="rappresentante" header="Rappresentante"></Column>
    </DataTable>

  </div>
  <div class="wrap-footer-main-dialog">
    <div class="footer-main-dialog">
      <Button 
          label="Chiudi" 
          icon="pi pi-times"
          iconPos="right" 
          class="p-button-secondary mr-3"
          @click="onCancelButton($event)" 
        />
        <Button 
          label="Esegui" 
          icon="pi pi-check"
          iconPos="right" 
          class="mr-3"
          @click="onOkButton($event)" 
        />
    </div>
  </div>
</template>

<script>

import { ref, getCurrentInstance, onMounted } from 'vue';
import Service from '@/services/ask-operation/operation-service'
import UtilityService from '@/services/ask-management/utility-service'
import { FilterMatchMode } from 'primevue/api';
import Loader from '@/components/Loader.vue'
import { useToast } from "primevue/usetoast";

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  components: {
    Loader
  },
    
  setup(props) {
    const page = { name: 'pods-dichiarazione-iva'}
    const loader = ref(false)
    const toast = useToast();

    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const service = new Service(self.$http, self.$eventBus)
    const utilityService = new UtilityService(self.$http, self.$eventBus)
    const filters = ref({
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
    });
    const items = ref(props.data)
    const selectedItems = ref(items.value);
    const selectedDaIva = ref();
    const selectedAdIva = ref();
    const ivas = ref([])
      
    onMounted(() =>{
      getTipiAliquotaIva()
    })

    const getTipiAliquotaIva = () => {
      loader.value = true
      utilityService.getTipiAliquotaIva().then((res) => {
        if (res.items.length > 0) {
          res.items.sort((a, b) => a.name - b.name)
          ivas.value = res.items
          selectedDaIva.value = ivas.value[res.items.length - 1].name
          selectedAdIva.value = ivas.value[0].name
        }
      })
      .finally(()=>{
        loader.value = false
      })
    }
      
    const onOkButton = () => {
      toast.removeGroup(page.name);
      
      if (Object.entries(selectedItems.value).length !== 0 && selectedDaIva.value !== null && selectedAdIva.value !== null) {
        loader.value = true
        service.downloadDichiarazioneIva(selectedItems.value, selectedDaIva.value, selectedAdIva.value)
        .finally(()=>{
          loader.value = false
        })
      } else {
        if (selectedItems.value.length == 0) {
          toast.add({severity:'warn', summary: 'Attenzione', detail:'Non hai selezionato nessun elemento', group: page.name});
        }
        if (selectedDaIva.value !== null || selectedAdIva.value !== null) {
          toast.add({severity:'warn', summary: 'Attenzione', detail:`Seleziona l'iva da applicare`, group: page.name});
        }

      }
    }


    const onCancelButton = () => {
      _reset()
       self.$eventBus.emit(`dialog-return-cancel-button`, {})
    }

    const _reset = () =>{
      selectedItems.value = []
    }


    return {
      page,
      filters,
      items,
      selectedItems,
      loader,
      ivas,
      selectedDaIva,
      selectedAdIva,
      onOkButton,
      onCancelButton
    }
  }
}


</script>


